import { trackApplicationEvent } from 'tracking/application/trackApplicationEvent';

export const trackRecaptchaSuccess = trackApplicationEvent('RECAPTCHA_SUCCESS');
export const trackRecaptchaFail = trackApplicationEvent('RECAPTCHA_FAIL');
